import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from './Constants';


function Meetings() {
	const [meetings, setMeetings] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');
	const [roleFilter, setRoleFilter] = useState('All');
	const [currentPage, setCurrentPage] = useState(1);
	const PAGE_SIZE = 20;

	useEffect(() => {
		const loadMeetings = async () => {
			try {
				const response = await axios.get(`${API_BASE_URL}/api/meetings`);
				const data = Array.isArray(response.data)
					? response.data
					: response.data?.data || [];
				setMeetings(data);
			} catch (requestError) {
				setError('Unable to load meetings.');
			} finally {
				setLoading(false);
			}
		};

		loadMeetings();
	}, []);

	const formatDate = (date) => {
		if (!date) return 'Not scheduled';
		return new Date(date).toLocaleString();
	};

	const filteredMeetings = meetings.filter((meeting) =>
		roleFilter === 'All' || (meeting.user?.role || '').toLowerCase() === roleFilter.toLowerCase()
	);

	const totalPages = Math.max(1, Math.ceil(filteredMeetings.length / PAGE_SIZE));
	const safeCurrentPage = Math.min(currentPage, totalPages);
	const startIndex = (safeCurrentPage - 1) * PAGE_SIZE;
	const paginatedMeetings = filteredMeetings.slice(startIndex, startIndex + PAGE_SIZE);

	useEffect(() => {
		setCurrentPage((page) => Math.min(page, totalPages));
	}, [filteredMeetings.length, totalPages]);

	useEffect(() => {
		setCurrentPage(1);
	}, [roleFilter]);

	if (loading) return <p>Loading meetings...</p>;
	if (error) return <p role="alert">{error}</p>;

	return (
        <>
        <h2 className='primary'>Google Meeting History</h2>
		<section className="meetings">
			<label htmlFor="role-filter"> Filter by Role: </label>
			<select
				id="role-filter"
				value={roleFilter}
				onChange={(event) => setRoleFilter(event.target.value)}
			>
				<option value="All">All</option>
				<option value="tutor">Tutor</option>
				<option value="student">Student</option>
			</select>
			{filteredMeetings.length === 0 ? (
				<p>No meetings found.</p>
			) : (
				<>
					<table className="table">
						<thead>
							<tr>
								<th>User ID</th>
								<th>Link Opened At</th>
								<th>Subject</th>
								<th>Opened By</th>
								<th>Course</th>
								<th>Scheduled</th>
								<th>Duration</th>
								<th>Role</th>
								<th>Meeting Link</th>
							</tr>
						</thead>
						<tbody>
							{paginatedMeetings.map((meeting) => {
								const session = meeting.session || {};
								const enrollment = session.enrollment || {};
								const user = meeting.user || {};

								return (
									<tr className="meeting-table" key={meeting.id}>
										<td>{user.name || 'N/A'}-{user.tag || 'N/A'}</td>
										<td>{formatDate(meeting.created_at)}</td>
										<td>{enrollment.subject || 'Meeting'}</td>
										<td>{user.name || 'N/A'}</td>
										<td>{enrollment.id}-{enrollment.course_name || 'N/A'}-{enrollment.tutor?.name || 'N/A'}</td>
										<td>{formatDate(session.scheduled_time)}</td>
										<td>{session.duration_minutes || 0} minutes</td>
										<td>{user.role || 'N/A'}</td>
										<td>{session.meeting_link || 'N/A'}</td>
									</tr>
								);
								})}
						</tbody>
					</table>

					<div className="pagination" style={{ marginTop: '12px', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
						<button
							type="button"
							disabled={safeCurrentPage === 1}
							onClick={() => setCurrentPage((page) => Math.max(page - 1, 1))}
						>
							Previous
						</button>

						{Array.from({ length: totalPages }, (_, index) => index + 1).map((pageNumber) => (
							<button
								type="button"
								key={pageNumber}
								onClick={() => setCurrentPage(pageNumber)}
								style={{
									fontWeight: pageNumber === safeCurrentPage ? 'bold' : 'normal',
									background: pageNumber === safeCurrentPage ? '#1d4ed8' : '#fff',
									color: pageNumber === safeCurrentPage ? '#fff' : '#000',
									border: '1px solid #d1d5db',
									padding: '6px 10px',
									cursor: 'pointer'
								}}
							>
								{pageNumber}
							</button>
						))}

						<button
							type="button"
							disabled={safeCurrentPage === totalPages}
							onClick={() => setCurrentPage((page) => Math.min(page + 1, totalPages))}
						>
							Next
						</button>
					</div>
				</>
			)}
		</section>
        </>
	);
}

export default Meetings;


